<!-- 確認画面用住所表示: 所在地5行セットを表示するコンポーネント -->
<template>
  <tr>
    <th rowspan="5">所在地</th>
    <td class="sub-label">郵便番号</td>
    <td>{{ address.zip || "—" }}</td>
  </tr>
  <tr>
    <td class="sub-label">都道府県</td>
    <td>{{ address.prefecture || "—" }}</td>
  </tr>
  <tr>
    <td class="sub-label">市区町村</td>
    <td>{{ address.city || "—" }}</td>
  </tr>
  <tr>
    <td class="sub-label">番地等</td>
    <td>{{ address.address1 || "—" }}</td>
  </tr>
  <tr>
    <td class="sub-label">建物名 等</td>
    <td>{{ address.building || "—" }}</td>
  </tr>
</template>

<script setup lang="ts">
interface AddressInfo {
  zip?: string | null;
  prefecture?: string | null;
  city?: string | null;
  address1?: string | null;
  building?: string | null;
}

defineProps<{
  address: AddressInfo;
}>();
</script>
